import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import './metaConversation.css';

interface Props {
  /** Estado da entrega no WhatsApp oficial: sent · delivered · read · played · failed (e deleted · edited, que não são deste aviso). */
  state?: string | null;
  /** Estado do envio na tela (o ícone de erro já aparece; com o motivo do servidor, o aviso o mostra). */
  status?: string | null;
  /** Motivo em português (da Meta traduzido ou da recusa do servidor). */
  error?: string | null;
}

/** "Não entregue" com o motivo, embaixo da mensagem enviada. Estados normais de entrega não mostram nada. */
export const WhatsAppDeliveryNote: React.FC<Props> = ({ state, status, error }) => {
  const failed = state === 'failed' || (status === 'error' && !!error);
  if (!failed) return null;
  return (
    <div className="wa-delivery-failed" role="alert">
      <FiAlertCircle size={12} aria-hidden="true" /> {error ? `Não entregue: ${error}` : 'Não entregue.'}
    </div>
  );
};
